<div class="customHeaderLabel" (click)="emitHeader($event); false" [ngClass]="{'disabled': isDisabled}">
  <span class="drill-down-btn" style="font-size: 18px; font-weight: initial; vertical-align: top; margin-right: 5px;">+</span>
  <span title="{{displayName}}">{{displayName}}</span>
</div>
